import React from "react";
import { Link } from "react-router-dom";

export const MenuItem = ({ item }) => {
  return (
    <Link to={`/menu/${item.id}`}>
      <div className=" w-full border border-gray p-1 pt-0 rounded-xl drop-shadow-lg">
        <span className=" flex justify-between">
          <h2 className=" font-bold text-lg ml-1 ">{item.name}</h2>
          <p className="font-semibold place-self-end text-base mr-2">
            $
            {item.price.toLocaleString(undefined, { minimumFractionDigits: 0 })}
          </p>
        </span>
        <span className=" flex gap-1">
          <figure className="w-[40%] self-center rounded-xl">
            <img
              loading="lazy"
              className=" object-contain rounded-xl"
              src={item.images.small}
              alt={item.name}
            />
          </figure>
          <span className="w-[60%] place-content-center">
            <h3 className="font-semibold text-lg">Ingredientes:</h3>
            <p className="text-sm">{item.ingredients.slice().join(", ")}</p>
            <span className=" font-light text-xs bg-gray-400 text-white w-fit self-end mt-2 p-1 rounded-lg">
              Papas no incluidas
            </span>
          </span>
        </span>
      </div>
    </Link>
  );
};
